import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { entryDateSelectionNameConfig } from './EntryDateSelection.name';

enum EntryDateSelection {
  currentMonth = '101',
  currentQuarter = '102',
  currentHalf = '103',
  currentPeriod = '104',
  quarter1 = '105',
  quarter2 = '106',
  quarter3 = '107',
  quarter4 = '108',
}

const entryDateSelectionMap = new Map([
  ['101', EntryDateSelection.currentMonth],
  ['102', EntryDateSelection.currentQuarter],
  ['103', EntryDateSelection.currentHalf],
  ['104', EntryDateSelection.currentPeriod],
  ['105', EntryDateSelection.quarter1],
  ['106', EntryDateSelection.quarter2],
  ['107', EntryDateSelection.quarter3],
  ['108', EntryDateSelection.quarter4],
]);

const rawValueToEntryDateSelection = rawValueToEnumWithDefault(
  entryDateSelectionMap,
  EntryDateSelection.currentMonth,
);

const entryDateSelectionToDisplay = enumToNameWithDefault(EntryDateSelection, entryDateSelectionNameConfig);

const entryDateSelectionToDisplayWithPrefix = enumToNameWithDefault(
  EntryDateSelection,
  entryDateSelectionNameConfig,
  true,
);

export {
  EntryDateSelection,
  entryDateSelectionToDisplay,
  entryDateSelectionToDisplayWithPrefix,
  rawValueToEntryDateSelection,
};
